import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/hvac';
export function FinalCTA() {
  return <section className="bg-charcoal px-4 py-5 sm:py-7" data-id="element-50" data-mp="3udyitut58tm7">
      <div className="mx-auto max-w-3xl" data-id="element-51" data-mp="c7aew89tyci4">
        <h2 className="text-center text-xl leading-tight text-white sm:text-3xl" data-id="element-52" data-mp="c8byj14ww7bg">
          One last question
        </h2>
        <p className="mt-2 text-sm font-medium leading-snug text-white/85 sm:text-base" data-id="element-53" data-mp="87jsegrc6ije">
          How many times have you known what the HVAC symptom was...
        </p>
        <p className="mt-1 text-sm font-medium leading-snug text-white/85 sm:text-base" data-id="element-54" data-mp="h5c6xip8hm5q">
          but still had to spend time searching through different resources to decide what to
          check next?
        </p>
        <p className="mt-1 text-sm font-medium leading-snug text-white/85 sm:text-base" data-id="element-55" data-mp="qxrpoi8cuero">
          You can keep jumping between scattered charts, manuals and references.
        </p>
        <p className="mt-1 text-sm font-semibold leading-snug text-white sm:text-base" data-id="element-56" data-mp="zxy200sbh8p9">
          Or you can open one organized visual diagnostic system.
        </p>
        <p className="mt-2 text-center font-display text-lg uppercase leading-tight text-diag sm:text-2xl" data-id="element-57" data-mp="2h2y6165565ra">
          Find the symptom. Follow the map. Check it. Verify it.
        </p>

        <a href={CHECKOUT_URL} className="mt-3 block" data-id="element-58" data-mp="2r1nmcuhe3i5f">
          <img src={HERO_IMAGE} alt="HVAC DIAGNOSTIC READY™ complete system" loading="lazy" className="mx-auto w-full max-w-md" data-id="element-59" data-mp="2r38ksv6trl8k" />
        </a>

        <p className="mt-2 text-center font-display text-xl uppercase text-white sm:text-2xl" data-id="element-60" data-mp="300spke3wbznx">
          🔧 HVAC DIAGNOSTIC READY™
        </p>
        <p className="mt-0.5 text-center text-xs font-extrabold uppercase tracking-wide text-white/80 sm:text-sm" data-id="element-61" data-mp="39sycvaj7dsws">
          The complete visual troubleshooting system for HVAC technicians
        </p>
        <p className="mt-0.5 text-center text-xs font-semibold text-white/70 sm:text-sm" data-id="element-62" data-mp="3islf1yjrb2qw">
          Cooling • Airflow • Electrical • Refrigerant • Compressor • Field Troubleshooting
        </p>

        <p className="mt-2 text-center font-display text-lg uppercase text-diag sm:text-xl" data-id="element-63" data-mp="1epie18o315au">
          🔥 Get the complete system today
        </p>
        <CTAButton className="mx-auto mt-1.5 max-w-md" sub="Immediate Access • Digital Delivery" subTone="light" data-id="element-64" data-mp="1si87fy5xxchz">
          🔧 YES! I WANT HVAC DIAGNOSTIC READY™
        </CTAButton>
        <p className="mt-1.5 text-center text-xs font-bold text-white/80" data-id="element-65" data-mp="22gnwlvleqbou">
          🛡️ 7-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}